export class EmailTemplateCategoryApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getPreview({ emailTemplateCategoryId, emailTemplateId }) {
    return this.#http.get(
      `/email-template-categories/${emailTemplateCategoryId}/templates/${emailTemplateId}/preview`,
    );
  }

  async getPreviewV2({ emailTemplateCategoryId, emailTemplateId }) {
    return this.#http.get(
      `/email-template-categories/${emailTemplateCategoryId}/templates/${emailTemplateId}/preview/v2`,
    );
  }
}
